import { useContext } from 'react';
import { BalanceSheetReportStore } from '../stores/balanceSheetReportStore';
import { StoreContext } from '@roc/feature-app-core';

export const useBalanceSheetReportStore = () =>
  useContext<{
    balanceSheetReportStore: BalanceSheetReportStore;
  }>(StoreContext);
